import { PRIORITIZE_NUDGE_TIMESTAMP } from '../constants';
import { getUserStore } from '../store/store';
import { setItem } from 'owa-local-storage';
import { mutatorAction } from 'satcheljs';
import { PrioritizeRequestStatus } from '../store/PrioritizeRequestStatus';
import type { MailboxInfo } from 'owa-client-types';
import type { DebugOutput } from 'owa-copilot-shared/lib/models/DebugOutput';

export const updatePrioritizeRequestStatusMutator: (
    mailboxInfo: MailboxInfo,
    status?: PrioritizeRequestStatus,
    shouldUpdatePrioritizeNudgeTimestamp?: boolean,
    skippedRowKeys?: string[],
    debugOutput?: DebugOutput
) => void = mutatorAction(
    'updatePrioritizeRequestStatus',
    (
        mailboxInfo: MailboxInfo,
        status?: PrioritizeRequestStatus,
        shouldUpdatePrioritizeNudgeTimestamp?: boolean,
        skippedRowKeys?: string[],
        debugOutput?: DebugOutput
    ): void => {
        const store = getUserStore(mailboxInfo);

        store.requestNumber = store.requestNumber + 1;

        if (status === PrioritizeRequestStatus.InProgress) {
            store.loadingMessageIndex = 0;
        }

        if (status !== undefined) {
            store.prioritizeRequestStatus = status;
        }

        if (shouldUpdatePrioritizeNudgeTimestamp) {
            setItem(window, PRIORITIZE_NUDGE_TIMESTAMP, Date.now().toString());
        }

        if (skippedRowKeys && skippedRowKeys.length > 0) {
            store.skippedRowKeys.push(...skippedRowKeys);
        }

        if (debugOutput) {
            store.debugOutput = debugOutput;
        }
    }
);
